// GRO-404: the shared-Slack flag as a component, so the board rows and the sidebar draw it one
// way. Links to the channel when Salesforce holds a URL, and is a plain flag when it holds only
// the channel id. The past-opportunity flag has no link, so each surface renders it inline.

import { httpsUrl } from '../lib/format';

const SLACK_TITLE =
  'We share a Slack Connect channel with this company — check it before sending anything cold';

// The v1 board's fixed-width flag.
export function SharedSlackFlag({ url }: { url: string | null }) {
  const href = httpsUrl(url);
  if (!href) return <span className="flag slack" title={SLACK_TITLE}>Shared Slack</span>;
  return (
    <a
      className="flag slack"
      href={href}
      target="_blank"
      rel="noopener"
      title={SLACK_TITLE + ' (opens the channel)'}
      onClick={event => event.stopPropagation()}
    >
      Shared Slack
    </a>
  );
}

// The v2 board's one-character glyph: `#`.
export function SharedSlackGlyph({ url }: { url: string | null }) {
  const href = httpsUrl(url);
  if (!href) return <span className="glyph slack" aria-label="Shared Slack channel" title={SLACK_TITLE}>#</span>;
  return (
    <a
      className="glyph slack"
      href={href}
      target="_blank"
      rel="noopener"
      aria-label="Shared Slack channel"
      title={SLACK_TITLE + ' (opens the channel)'}
      onClick={event => event.stopPropagation()}
    >
      #
    </a>
  );
}

// The compact "Slack" chip the Accounts oversight page introduced (20 Oct), now on the strategist
// board too. Links to the channel when Salesforce holds a URL.
export function SharedSlackChip({ url }: { url: string | null }) {
  const href = httpsUrl(url);
  if (!href) return <span className="ovflag slack" title={SLACK_TITLE}>Slack</span>;
  return (
    <a
      className="ovflag slack"
      href={href}
      target="_blank"
      rel="noopener"
      title={SLACK_TITLE + ' (opens the channel)'}
      onClick={event => event.stopPropagation()}
    >
      Slack
    </a>
  );
}
